"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var renderContentListItems = function renderContentListItems(content) {
  return content.map(function (item, index) {
    var key = "".concat(item.text, "-").concat(index);
    return item.url ? /*#__PURE__*/_react["default"].createElement("li", {
      style: {
        marginBottom: "0.3rem"
      },
      key: key
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: item.url
    }, item.text)) : /*#__PURE__*/_react["default"].createElement("li", {
      style: {
        marginBottom: "0.3rem"
      },
      key: key
    }, item.text);
  });
};
var _default = exports["default"] = renderContentListItems;